goog.provide('el8.app.settings.epcsSettings');

goog.require('el8.app.settings.util');
goog.require('el8.template.app.settings.epcsSettings');

//
// Shows 4 iframes on pages at MDToolbox required for EPCS: access control, rx listing, audit log, and alerts
//
el8.app.settings.epcsSettings = (function() {
    var that = {};

    that = {
        showTabFn: function($container) {
            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('mdtParams'),
                success: function(data) {
                    var url = data.url;
                    delete data.url;

                    var signedUp = el8.data.currUser.isEpcsEnabled();
                    var signupURL = url + '?' + $.param($.extend({page: 'epcssignup'}, data));

                    var accessURL = url + '?' + $.param($.extend({page: 'epcsaccesscontrol'}, data));
                    var listingURL = url + '?' + $.param($.extend({page: 'RXLISTING'}, data));
                    var auditURL = url + '?' + $.param($.extend({page: 'AUDITLOGREPORT'}, data));
                    var alertsURL = url + '?' + $.param($.extend({page: 'rxalerts'}, data));

                    $container.html(el8.template.app.settings.epcsSettings.content({
                        isPhysician: el8.data.currUser.isPhysician(),
                        isAdmin: el8.data.currUser.isPracticeAdmin(),
                        notReadyForSignUp: data.no_spi,
                        signedUp: signedUp,
                        accessURL: accessURL,
                        listingURL: listingURL,
                        auditURL: auditURL,
                        alertsURL: alertsURL
                    })).show();
                }
            });

            $container.on('click', '.epcs-signup-trigger',  function() {
                $('.epcs-signup-trigger-loading', $container).show();
                $('.epcs-signup-trigger', $container).hide();
                that._openSignupURL( function() {
                    $('.epcs-signup-trigger-loading', $container).hide();
                    $('.epcs-signup-trigger', $container).show();
                    $.el8_ajax({
                        type: 'POST',
                        async: true,
                        url: el8Globals['PRACTICE_PATH']+'epcs-setup-started'
                    });
                });
            });

            $container.on('click', '.epcs-update-token-trigger',  function() {
                $('.epcs-update-token-trigger-loading', $container).show();
                $('.epcs-update-token-trigger', $container).hide();
                that._openSignupURL( function() {
                    $('.epcs-update-token-trigger-loading', $container).hide();
                    $('.epcs-update-token-trigger', $container).show();
                });
            });
        },

        _openSignupURL: function(successCb) {
            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('mdtEpcsSignup'),
                async: true,
                success: function(data) {
                    var url = data.url;
                    delete data.url;

                    if (successCb) { successCb(); }
                    var signupURL = url + '?' + $.param(data);
                    window.open(signupURL, "_blank");
                },
                error: function() {
                    el8.uiwidget.alert('Unable to begin registration for EPCS with MDToolbox.  Please make sure you have enabled eRx with SureScripts first.');
                }
            });
        }
    };

    return that;
})();
